import { Toast } from 'vant'
import { sendSms, loginSms } from '@/api'
import countryCodeSelector from 'vue-country-code-selector'
export default {
  components: {
    countryCodeSelector
  },
  props: [],
  name: 'resetPassword-page',
  data () {
    return {
      user: {
        phone: null,
        code: null,
        region: 86
      },
      timeNum: null
    }
  },
  computed: {
  },
  watch: {
  },
  created () { },
  mounted () { },
  destroyed () { },
  methods: {
    // 获取验证码
    async inputVerificationCode (type) {
      if (!type) {
        Toast({ message: '请输入手机号', type: 'fail' })
        return
      }
      const { error } = await sendSms({ phone: this.user.phone, region: '+' + String(this.user.region) })
      if (error.returnCode === 0) {
        this.timeNum = 60
        const set = setInterval(() => {
          this.timeNum = --this.timeNum
        }, 1000)
        setTimeout(() => {
          this.timeNum = null
          clearInterval(set)
        }, 60000)
      }
    },
    async loginBtnClicked () {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (!this.user.phone) {
        Toast({ message: '手机号输入有误', type: 'fail' }); return
      }
      if (!this.user.code) {
        Toast({ message: '验证码输入有误', type: 'fail' })
      }
      this.user.region = '+' + String(this.user.region)
      const { data, error } = await loginSms(this.user)
      if (data && error.returnCode === 0) {
        if (isAndroid) { // android终端
          const url = 'https://kewang90.wixsite.com/prepcourse'
          window.open(url)
        } else if (isiOS) { // ios终端
          window.location.href = 'https://kewang90.wixsite.com/prepcourse'
        }
      } else {
        Toast({ message: error.returnMessage, type: 'error' })
      }
    }
  }
}
